<header>
  <dx-toolbar class="header-toolbar">
    @if (menuToggleEnabled) {
      <dxi-toolbar-item
        location="before"
        widget="dxButton"
        cssClass="menu-button"
              [options]="{
        icon: 'menu',
        stylingMode: 'text',
        onClick: toggleMenu
      }">
      </dxi-toolbar-item>
    }
    @if (title) {
      <dxi-toolbar-item location="before"
        cssClass="header-title"
        [text]="title">
      </dxi-toolbar-item>
    }
    @if (chartVisible) {
      <dxi-toolbar-item location="after"
        widget="dxButton"
        [options]="chartButtonOptions"
        >
      </dxi-toolbar-item>
    }
    @if (backVisible) {
      <dxi-toolbar-item location="after"
        widget="dxButton"
        [options]="backButtonOptions"
        >
      </dxi-toolbar-item>
    }
    @if (refreshVisible) {
      <dxi-toolbar-item location="after"
        widget="dxButton"
        [options]="refreshButtonOptions"
        >
      </dxi-toolbar-item>
    }
    @if (collapseVisible) {
      <dxi-toolbar-item location="after"
        widget="dxButton"
        [options]="collapseButtonOptions"
        >
      </dxi-toolbar-item>
    }
    @if (expandVisible) {
      <dxi-toolbar-item location="after"
        widget="dxButton"
        [options]="expandButtonOptions"
        >
      </dxi-toolbar-item>
    }
    <dxi-toolbar-item location="after"
      locateInMenu="auto"
      menuItemTemplate="menuItem">
      <div *dxTemplate="let data of 'item'">
        <dx-button class="user-button authorization"
          width="40px"
          height="100%"
          stylingMode="text">
          <div *dxTemplate="let data of 'content'">
            <app-user-panel [user]="user" [menuItems]="userMenuItems" menuMode="context"></app-user-panel>
          </div>
        </dx-button>
      </div>
    </dxi-toolbar-item>
  </dx-toolbar>
</header>
